namespace Areas.Analysis {
    "use strict";

    export function analysisLink(cellElement, cellInfo) {
        var projectId = cellInfo.data.projectId;
        var linkInfo = "<a href= '/Analysis/Project/Detail/" + String(projectId) + "'>Analysis</a>";
        cellElement.html(linkInfo);
      
    }

    export function appPercent(cellElement, cellInfo) {

        cellElement.html(cellInfo.text);
        if (cellInfo.data.appropriationCommittedPercent > 1) {
            cellElement.css("background-color", "lightpink");
        }
    }

    export function budgetPercent(cellElement, cellInfo) {

        cellElement.html(cellInfo.text);
        if (cellInfo.data.budgetCommittedPercent > 1) {
            cellElement.css("background-color", "lightpink");
        }
    }
}